jQuery( function ( $ ) {
    // taken and modified from https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role

    $( 'section.page_tabs' ).each( function () {
        // tab functionality for desktop
        let $tablist = $( '[role=tablist]', this );
        let $tabs = $( '[role=tab]', $tablist );
        let $tabpanel_wrap = $( '.tabpanel-wrap', this );
        let $tab_panels = $( '[role=tabpanel]', this );
        let tab_focus = 0;

        $tablist
            .on( 'click', 'button[role=tab]', function ( e ) {
                select_tab( $(this).data( 'uniqid' ) );
            })
            .on( 'keydown', function ( e ) {
                if ( [ 37, 39 ].includes( e.keyCode ) ) {
                    $tabs.eq( tab_focus ).attr( "tabindex", -1 );

                    if ( e.keyCode === 39 ) {
                        // Move right
                        tab_focus = ( tab_focus + 1 ) % $tabs.length;
                    } else {
                        // Move left
                        tab_focus = ( tab_focus - 1 ) % $tabs.length;
                    }
            
                    $tabs.eq( tab_focus ).attr( "tabindex", 0 );
                    $tabs.eq( tab_focus ).trigger( 'focus' );
                }
            });

        $tabpanel_wrap.on( 'init afterChange', function ( e, slick, index ) {
            slick.initADA();

            // slick doesn't handle tabindices on textareas?
            $( 'textarea', slick.$list ).each( function () {
                $(this).attr( 'tabindex', $(this).closest( '.slick-slide' ).attr( 'tabindex' ) );
            });
            // slick adds tabindex 0 to select elements within the current slide, which auto-focus back to `select + select2`, which makes it impossible to tab backwards
            $( 'select.select2-hidden-accessible', slick.$list ).attr( 'tabindex', -1 );
            
            slick.$slides.filter( '.slick-active' ).removeAttr( 'tabindex' );
            slick.$list.css( 'height', 'auto !important' );
        });

        $tabpanel_wrap.slick({
            dots: false,
            arrows: false,
            fade: true,
            adaptiveHeight: true,
            draggable: false,
            accessibility: false,
            waitForAnimate: false,
        });
        
        function select_tab ( uniqid ) {
            $tabs.each( function () {
                let is_selected = $(this).data( 'uniqid' ) == uniqid;
                $(this).attr( 'aria-selected', is_selected ).toggleClass( 'btn-primary', is_selected ).toggleClass( 'btn-light', !is_selected );
            });
            $tabpanel_wrap.slick( 'slickGoTo', $tab_panels.filter(`[data-uniqid=${ uniqid }]`).data( 'slick-index' ) );
        }

    });

});